export default "__VITE_ASSET__DSEqSCwf__"